/**
 * useUser Composable
 * 
 * A composable that provides user-related functionality and state management.
 * It handles user data access, authentication state, and user initials generation.
 * 
 * Features:
 * - Current user data access
 * - Authentication state checking
 * - User initials generation from name
 * 
 * @returns {Object} An object containing user data, auth state, and user initials
 */

import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

export function useUser() {
  const authStore = useAuthStore()

  const userInitials = computed(() => {
    const user = authStore.currentUser
    if (!user) return ''

    const firstName = user.first_name || ''
    const lastName = user.last_name || ''

    return `${firstName[0] || ''}${lastName[0] || ''}`.toUpperCase()
  })

  const currentUser = computed(() => authStore.currentUser)
  const isAuthenticated = computed(() => authStore.isAuthenticated)

  return {
    userInitials,
    currentUser,
    isAuthenticated
  }
} 